module.exports = __webpack_public_path__ + "static/img/icon-coat-hanger.6bd32092.png";